import * as i0 from "@angular/core";
export class MailToStore {
}
MailToStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MailToStore_Factory() { return new MailToStore(); }, token: MailToStore, providedIn: "root" });
export var MailToStoreKeys;
(function (MailToStoreKeys) {
})(MailToStoreKeys || (MailToStoreKeys = {}));
